import { render, staticRenderFns } from "./Ot-Setting.vue?vue&type=template&id=3dfb1272"
import script from "./Ot-Setting.vue?vue&type=script&lang=js"
export * from "./Ot-Setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports